export default class SoundEffectCommandOptions {
  constructor(
    public startTime: number | undefined,
    public endTime: number | undefined,
  ) {}
}
